<template>
  <LeftSidebar
    :visible="visible"
    :title="$lang.newActivity"
    bodyClass="overflow-y-hidden"
    titleClass="padding-x-16"
    :hasFooter="false"
    :hasHeaderRightIcon="false"
  >
    <div v-if="visible" class="height-percent-100">
      <ActivityForm :submitMethod="addActivity" @handleClose="handleClose" />
    </div>
  </LeftSidebar>
</template>

<script>
import { LeftSidebar } from "@/components/re-design";
import ActivityForm from "./ActivityForm.vue";
import { addActivity } from "@/services";
import { toRefs } from "vue";
export default {
  components: { LeftSidebar, ActivityForm },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { visible } = toRefs(props);
    
    // bind emits
    const handleClose = () => emit("handleClose");

    // return data to be used in template
    return { visible, addActivity, handleClose };
  },
};
</script>
